import React from 'react';
import { motion } from 'motion/react';
import { FeatureType, BusinessIdea } from '@/src/types';

interface BreadcrumbsProps {
  activeFeature: FeatureType | null;
  isRevealed: boolean;
  isScrutinyActive: boolean;
  selectedIdea: BusinessIdea | null;
  onNavigateHome: () => void;
  onNavigateFeature: () => void;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ 
  activeFeature, 
  isRevealed, 
  isScrutinyActive, 
  selectedIdea,
  onNavigateHome,
  onNavigateFeature
}) => {
  const getFeatureName = () => {
    if (activeFeature === FeatureType.Optimize) return 'Optimize Hub';
    if (isScrutinyActive) return 'Scrutiny Hub';
    
    // For Scan and Discovery, we check hubOrigin of result or activeFeature
    if (activeFeature === FeatureType.Scan) return 'Launchpad';
    if (activeFeature === FeatureType.ReverseDiscovery || activeFeature === FeatureType.DensityScout) return 'Discovery Hub';
    
    if (selectedIdea) {
      if (selectedIdea.hubOrigin === 'launchpad') return 'Launchpad';
      if (selectedIdea.hubOrigin === 'discovery') return 'Discovery Hub';
      if (selectedIdea.hubOrigin === 'optimize') return 'Optimize Hub';
    }

    return null;
  };

  const featureName = getFeatureName();
  const showBreadcrumbs = featureName !== null || isRevealed || isScrutinyActive || selectedIdea;

  if (!showBreadcrumbs) return <div className="h-4" />; // Spacer

  return (
    <motion.nav 
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-[0.2em] text-white/40 mb-8 px-4 sm:px-8 max-w-[1600px] mx-auto"
    >
      <button 
        onClick={onNavigateHome}
        className="hover:text-[#F26522] transition-colors cursor-pointer"
      >
        HOME
      </button>
      
      {featureName && (
        <>
          <span className="text-white/20">/</span>
          <button 
            onClick={onNavigateFeature}
            className={`transition-colors cursor-pointer ${!selectedIdea ? 'text-white' : 'hover:text-[#F26522]'}`}
          >
            {featureName}
          </button>
        </>
      )}

      {selectedIdea && (
        <>
          <span className="text-white/20">/</span>
          <span className="text-white truncate max-w-[200px]">
            {selectedIdea.title}
          </span>
        </>
      )}
    </motion.nav>
  );
};

export default Breadcrumbs;
